import Vuex from "vuex";
import Vue from "vue";
import user from "./modules/user";
import organization from "./modules/organization";
import requests from "./modules/requests";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        organization,
        requests
    }
})